"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = valueAddedSubjectPriceDifference;

function valueAddedSubjectPriceDifference(ctx, rule, subject, resultCtx) {
  var prevPrice = subject.price || 0;
  var _resultCtx$partial = resultCtx.partial,
      _resultCtx$partial$pr = _resultCtx$partial.price,
      nextPrice = _resultCtx$partial$pr === void 0 ? prevPrice : _resultCtx$partial$pr,
      _resultCtx$partial$in = _resultCtx$partial.indirectSubjects,
      indirectSubjects = _resultCtx$partial$in === void 0 ? [] : _resultCtx$partial$in;
  var indirectSum = indirectSubjects.reduce(function (sum, indirect) {
    return sum + (indirect.price || 0);
  }, 0);
  return prevPrice - (nextPrice + indirectSum);
}